var _rect, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclinicalworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    role: "img",
    "aria-label": "eClinicalWorks",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 238,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 30,
    r: 12,
    fill: "none",
    stroke: "#0a529c",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30 a6 6 0 0 1 12 0",
    fill: "none",
    stroke: "#e6731a",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 38,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 600,
    fill: "#0a529c"
  }, "eClinical", /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700
  }, "Works"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclinicalworks);
export default __webpack_public_path__ + "static/media/eclinicalworks.1161ea4231af3a7809b46be66e052616.svg";
export { ForwardRef as ReactComponent };